import { FetchProfile } from './../model/fetchprofile';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ApiResult } from '../model/apiresult';
import { environment as env } from '@environments/environment'
import { tap } from 'rxjs/operators';
@Injectable({providedIn: 'root'})
export class ProfileService {
    public showSpinner = new BehaviorSubject(false);
    constructor(private http: HttpClient) { }

    fetchProfile() {
        return this.http.post<ApiResult<FetchProfile>>(env.apiUrl + 'Lookup/fetchProfile',null).pipe(
            tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false))
        );
    }

}